import { useEffect, useState } from "react";
import { api, formatError } from "../lib/api";
import { Card } from "../components/ui/card";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger, DialogFooter } from "../components/ui/dialog";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../components/ui/select";
import { toast } from "sonner";
import { Plus } from "lucide-react";
import { useAuth } from "../context/AuthContext";

export default function Projects() {
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ name: "", developer: "", project_type: "mandate", division: "Mandate", location: "", city: "", configuration: "", description: "" });
  const { user } = useAuth();
  const canCreate = ["super_admin","partner","management","business_head"].includes(user?.role);
  const load = () => api.get("/projects").then(r => setItems(r.data));
  useEffect(() => { load(); }, []);
  const submit = async () => {
    try { await api.post("/projects", form); toast.success("Project created"); setOpen(false); load(); }
    catch (e) { toast.error(formatError(e.response?.data?.detail) || e.message); }
  };
  return (
    <div className="space-y-6 animate-in">
      <div className="flex items-end justify-between">
        <div>
          <div className="text-[11px] uppercase tracking-[0.3em] text-muted-foreground">Master</div>
          <h1 className="font-serif-display text-3xl">Projects</h1>
        </div>
        {canCreate && (
          <Dialog open={open} onOpenChange={setOpen}>
            <DialogTrigger asChild><Button data-testid="new-project-btn"><Plus size={14} className="mr-1"/> New Project</Button></DialogTrigger>
            <DialogContent>
              <DialogHeader><DialogTitle>Create Project</DialogTitle></DialogHeader>
              <div className="grid grid-cols-2 gap-3">
                <div className="col-span-2"><Label>Name</Label><Input value={form.name} onChange={e => setForm({ ...form, name: e.target.value })} data-testid="project-name-input"/></div>
                <div><Label>Developer</Label><Input value={form.developer} onChange={e => setForm({ ...form, developer: e.target.value })}/></div>
                <div><Label>Type</Label>
                  <Select value={form.project_type} onValueChange={v => setForm({ ...form, project_type: v, division: v === "retail" ? "Retail" : v === "home_loan" ? "Home Loan" : "Mandate" })}>
                    <SelectTrigger><SelectValue/></SelectTrigger>
                    <SelectContent><SelectItem value="mandate">Mandate</SelectItem><SelectItem value="retail">Retail</SelectItem><SelectItem value="home_loan">Home Loan</SelectItem></SelectContent>
                  </Select>
                </div>
                <div><Label>Location</Label><Input value={form.location} onChange={e => setForm({ ...form, location: e.target.value })}/></div>
                <div><Label>City</Label><Input value={form.city} onChange={e => setForm({ ...form, city: e.target.value })}/></div>
                <div className="col-span-2"><Label>Configuration</Label><Input value={form.configuration} onChange={e => setForm({ ...form, configuration: e.target.value })}/></div>
              </div>
              <DialogFooter><Button onClick={submit} data-testid="project-submit-btn">Save Project</Button></DialogFooter>
            </DialogContent>
          </Dialog>
        )}
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {items.map(p => (
          <Card key={p.id} className="p-5">
            <div className="flex items-center justify-between">
              <div className="font-mono text-[11px] text-muted-foreground">{p.project_id}</div>
              <span className={`text-[10px] uppercase tracking-widest px-2 py-0.5 rounded border ${p.project_type === "mandate" ? "bg-accent/10 text-accent border-accent/30" : "bg-secondary border-border"}`}>{p.project_type}</span>
            </div>
            <div className="font-serif-display text-xl mt-2">{p.name}</div>
            <div className="text-xs text-muted-foreground mt-1">{p.developer} · {p.location}, {p.city}</div>
            <div className="text-xs mt-2">{p.configuration}</div>
          </Card>
        ))}
      </div>
    </div>
  );
}
